// eslint-disable-next-line import/prefer-default-export
export const CURRENT_USER = 'CURRENT_USER';
export const ADDRESSES_USER = 'ADDRESSES_USER';
